import $ from 'jquery';
import {InvoiceLine} from './Invoice';

class InvoiceLineTable {

  constructor(form) {
    this.form = form;
    this.invoice = form.invoice;
    this.$table = form.$form.find('#invoice_lines');
    this.$tbody = this.$table.children('tbody');
    this.colCount = 6;
  }

  isEmpty() {
    return !this.invoice.lines.length;
  }

  emptyRow() {
    this.$tbody.empty();

    var $tr = $('<tr/>').addClass('empty-lines').appendTo(this.$tbody);
    var $td = $('<td/>')
      .attr('colspan', this.colCount)
      .addClass('text-muted')
      .appendTo($tr);
    $td.text('This invoice has no additional invoice lines');
  }

  buildRows() {
    this.$tbody.find('tr.empty-lines').remove();
    let _this = this;

    this.invoice.lines.forEach(function(item, index, array) {
      let $tr = _this.buildRow(item);
      _this.$tbody.append($tr);
    });
  }

  insertRow(ix, line) {
    let $trEmpty = this.$tbody.find('tr.empty-lines');
    if ($trEmpty.length) {
      this.buildRows();
    }
    else {
      $trEmpty.remove();
      let $tr = this.buildRow(line);
      if (ix > 0) {
        this.$tbody.find('tr:eq(' + (ix-1) + ')').after($tr);
      }
      else {
        this.$tbody.append($tr);
      }
    }
  }

  buildRow(line) {
    let $tr = $('<tr/>')
      .attr('data-uuid', line.uuid)
      .data('item', line);

    if (line.is_new) {
      $tr.addClass('info');
    }

    let $td = $('<td/>')
      .appendTo($tr);

    if (line.hasError('name')) {
      $td.addClass('has-error')
    }

    $('<input/>').attr('type', 'text')
      .addClass('form-control form-control-sm')
      .attr('name', 'line_name[]')
      .attr('data-field', 'name')
      .val(line.name)
      .appendTo($td);


    let $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'line_uuid[]')
      .attr('data-field', 'uuid')
      .val(line.uuid)
      .appendTo($td);

    $td = $('<td/>').addClass('text-center')
      .appendTo($tr);

    if (line.hasError('amount')) {
      $td.addClass('has-error')
    }

    $ig = $('<div/>').addClass('input-group input-group-sm')
      .appendTo($td);

    let addonDiv = $('<div/>')
      .addClass('input-group-prepend')
      .appendTo($ig);
    $('<span/>').addClass('input-group-addon')
      .text('$')
      .appendTo(addonDiv);
    $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
      .attr('name', 'line_amount[]')
      .attr('data-field', 'amount')
      .val(line.amount)
      .appendTo($ig);


    $td = $('<td/>').addClass('text-center').appendTo($tr);
    let $ig = $('<div/>').addClass('checkbox mb-0 mt-1')
      .appendTo($td);
    let $label = $('<label/>').appendTo($ig);
    let $chk = $('<input/>').attr('type', 'checkbox')
      .attr('data-bill_to_client', true)
      .appendTo($label);
    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'line_bill_to_client[]')
      .attr('data-field', 'bill_to_client')
      .val(line.bill_to_client ? 1 : 0)
      .appendTo($td);
    $chk.prop('checked', line.bill_to_client);

    $td = $('<td/>').addClass('text-center').appendTo($tr);
    $ig = $('<div/>').addClass('checkbox mb-0 mt-1')
      .appendTo($td);
    $label = $('<label/>').appendTo($ig);
    $chk = $('<input/>').attr('type', 'checkbox')
      .attr('data-bill_by_adjuster', true)
      .appendTo($label);
    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'line_bill_by_adjuster[]')
      .attr('data-field', 'bill_by_adjuster')
      .val(line.bill_by_adjuster ? 1 : 0)
      .appendTo($td);
    $chk.prop('checked', line.bill_by_adjuster);

    $td = $('<td/>').addClass('text-center').appendTo($tr);
    $ig = $('<div/>').addClass('checkbox mb-0 mt-1')
      .appendTo($td);
    $label = $('<label/>').appendTo($ig);
    $chk = $('<input/>').attr('type', 'checkbox')
      .attr('data-taxable', true)
      .appendTo($label);
    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'line_taxable[]')
      .attr('data-field', 'taxable')
      .val(line.taxable ? 1 : 0)
      .appendTo($td);
    $chk.prop('checked', line.taxable);

    $td = $('<td/>').addClass('text-center')
      .appendTo($tr);
    let $btn = $('<button/>').attr('type', 'button')
      .addClass('btn').addClass('btn-danger')
      .attr('data-action', 'remove-line')
      .appendTo($td);
    $('<i/>').addClass('fa fa-trash').appendTo($btn);

    return $tr;
  }

  init() {
    this.setupEvents();

    if (this.isEmpty()) {
      this.emptyRow();
    }
    else {
      this.buildRows();
    }
  }

  clearNewRow() {
    this.$table.find('#new_line_name').val('');
    this.$table.find('#new_line_amount').val('');
    this.$table.find('#new_line_bill_to_client,#new_line_bill_by_adjuster').prop('checked', true);
    this.$table.find('button[data-action=add-line]').prop('disabled', true);
  }

  addRow(btn) {
    let data = this.getNewLineData();
    let line = new InvoiceLine(data);
    let ix = this.invoice.addLine(line);
    this.insertRow(ix, line);
    this.clearNewRow();
  }

  removeRow(btn) {
    let $tr = $(btn).closest('tr');
    let uuid = $tr.data('uuid');
    let $trNext = $tr.next('tr');

    $tr.remove();

    this.invoice.removeLine(uuid);

    if (this.isEmpty()) {
      this.emptyRow();
    }
  }

  toggleCheckbox(chk) {
    let $chk = $(chk);
    let $hidden = $chk.closest('td').find('input:hidden');
    $hidden.val($chk.is(':checked') ? 1 : 0);
  }

  getNewLineData() {
    let data = {};
    data.valid = true;
    data.is_new = true;
    data.name = this.$table.find('#new_line_name').val();
    data.amount = parseFloat(this.$table.find('#new_line_amount').val());
    data.bill_to_client = this.$table.find('#new_line_bill_to_client').is(':checked');
    data.bill_by_adjuster = this.$table.find('#new_line_bill_by_adjuster').is(':checked');

    if (data.amount !== null && isNaN(data.amount)) {
      data.valid = false;
    }
    if (!data.name || !$.trim(data.name).length) {
      data.valid = false;
    }

    return data;
  }

  getRowData($tr) {
    let data = {};
    $tr.find('[data-field]').each(function(ix) {
      let $el = $(this);
      data[$el.data('field')] = $el.val();
    });
    return data;
  }

  validateNewRow() {
    let data = this.getNewLineData();

    if (data.valid) {
      this.$table.find('button[data-action=add-line]').prop('disabled', false);
    }
    else {
      this.$table.find('button[data-action=add-line]').prop('disabled', true);
    }
  }

  highlightIfDirty($tr) {
    let line = $tr.data('item');
    if (line.is_new) return;

    let data = this.getRowData($tr);
    if (line.isDirty(data)) {
      $tr.addClass('warning');
    }
    else {
      $tr.removeClass('warning');
    }
  }

  setupEvents() {
    let _this = this;

    this.$table.on('click', '[data-action=add-line]', function(e) {
      _this.addRow(e.currentTarget);
      _this.form.calculateTotal();
    }).on('click', '[data-action=remove-line]', function(e) {
      _this.removeRow(e.currentTarget);
      _this.form.calculateTotal();
    }).on('keyup', 'tfoot input:text,tfoot input[type=text]', function(e) {
      _this.validateNewRow();
      _this.form.calculateTotal();
    }).on('click', 'tbody input:checkbox', function(e) {
      _this.toggleCheckbox(e.currentTarget);
      _this.highlightIfDirty($(e.currentTarget).closest('tr'));
      _this.form.calculateTotal();
    }).on('keyup', 'tbody input[type=text], tbody input[type=text]', function(e) {
      _this.highlightIfDirty($(e.currentTarget).closest('tr'));
      _this.form.calculateTotal();
    });
  }
}

export default InvoiceLineTable;
